import { SimpleForm, Loading } from 'react-admin';
import {
  CampaignLineItemsSelectInput,
  CurrentLineItemDateInputGroup,
  FormDivider,
  FormHeader,
  FormSectionHeader,
  LineItemTargetListInput,
} from './form-components';
import { CreativesFormProps } from './fma-creatives';
import { CreativeToolbar } from './shared';
import { useRecordContext } from 'react-admin';
import { useNativeLineItem } from './hooks/useNativeLineItem';

export const BannerTargetingsForm = ({ type, ...rest }: CreativesFormProps) => {
  const record = useRecordContext();

  // Resolve the parent line item from native data for BOTH id forms — the
  // Placements.IO API shut off at contract end, so the legacy 'line_items'
  // proxy can no longer serve imported line items. On EDIT a saved row prefers
  // its native lineItemId FK; on CREATE only placementsLineItemId is seeded
  // (native UUID or legacy numeric id, which useNativeLineItem translates via
  // externalPioId).
  const lineItemKey = record.lineItemId ?? record.placementsLineItemId;
  const { lineItem, isLoading, error } = useNativeLineItem(lineItemKey);
  if (isLoading) {
    return <Loading />;
  }
  if (error) {
    return <p>ERROR: {error.toString()}</p>;
  }
  if (!lineItem) return null;

  const campaignId = lineItem.campaignId;

  const defaultValues = {
    ...rest.defaultValues,
    startsAt: lineItem.startDate,
    endsAt: lineItem.endDate,
  };

  return (
    <SimpleForm
      {...rest}
      defaultValues={defaultValues}
      toolbar={<CreativeToolbar />}
      mode="onBlur"
      reValidateMode="onBlur"
    >
      <FormHeader>{`${type} Banner Targeting`}</FormHeader>

      <CampaignLineItemsSelectInput campaignId={campaignId} />

      <FormSectionHeader>Banner Targeting Details</FormSectionHeader>

      <CurrentLineItemDateInputGroup />
      <FormDivider />

      <FormSectionHeader>Targeting Details</FormSectionHeader>

      <LineItemTargetListInput lineItemId={lineItemKey} />
    </SimpleForm>
  );
};
